import { conversationOrder, conversations, people } from "../../data/demoContent";

export const ConversationList = ({ selected, onOpen }) => (
  <div className="flex-1 overflow-y-auto px-4 pb-4" data-testid="conversation-list">
    <div className="mb-2 flex items-baseline justify-between px-1">
      <h4 className="text-[18px] font-bold tracking-tight text-white">Messages</h4>
      <span className="text-[10px] text-white/55">Sample content — fictional demo</span>
    </div>
    <ul className="space-y-1">
      {conversationOrder.map((id) => {
        const p = people[id];
        const c = conversations[id];
        const active = selected === id;
        return (
          <li key={id}>
            <button
              type="button"
              onClick={() => onOpen(id)}
              data-testid={`conversation-item-${id}`}
              aria-current={active ? "true" : undefined}
              className={`flex w-full items-center gap-3 rounded-[18px] px-2.5 py-2 text-left transition-colors ${active ? "bg-white/[0.09]" : "hover:bg-white/[0.05]"}`}
            >
              <img src={p.avatar} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover" />
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between">
                  <span className="text-[14px] font-semibold text-white">{p.name}</span>
                  <span className="text-[11px] text-white/55">{c.time}</span>
                </span>
                <span className="block truncate text-[12.5px] text-white/55">{c.preview}</span>
              </span>
              {c.unread > 0 && (
                <span className="grid h-5 min-w-5 place-items-center rounded-full bg-[#7866E8] px-1.5 text-[10px] font-bold text-white">{c.unread}</span>
              )}
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);
